<template>
	<ul :class="classes">
		<li v-for="commitmentFilter in filteredFilterCounts"
			:key="commitmentFilter.type"
		>
			<NumberChip
				:class-name="`commitment-filters__filter commitment-filters__filter--${ commitmentFilter.type }`"
				:is-highlighted="commitmentFilter.type === selectedCommitmentType"
				:label="$t( `common.CommitmentFilters_${ commitmentFilter.type }Label` )"
				:number="commitmentFilter.count"
				:scheme="commitmentFilterColorScheme[ commitmentFilter.type ]"
				@click="$emit( 'filterByType', commitmentFilter.type )"
			/>
		</li>
	</ul>
</template>

<script>
import { CommitmentFilterType } from "@teaming/common-enums";
import NumberChip, { schemes } from "../NumberChip";

export default {
	name: "CommitmentFilters",
	emits: [
		"filterByType",
	],
	components: {
		NumberChip,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		/**
		 * @type {Array.<{count:Number, type:CommitmentFilterType}>}
		 */
		filters: {
			type: Array,
			required: true,
		},
		/**
		 * @type {CommitmentFilterType}
		 */
		selectedCommitmentType: {
			type: String,
			required: true,
		},
		omittedFilterTypes: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		classes() {
			return {
				"commitment-filters": true,
				[ this.className ]: !!this.className,
			};
		},
		commitmentFilterColorScheme() {
			return {
				[ CommitmentFilterType.COMPLETE ]: schemes.DEFAULT,
				[ CommitmentFilterType.DUE_IN_NEXT_WEEK ]: schemes.DEFAULT,
				[ CommitmentFilterType.NO_DUE_DATE ]: schemes.YELLOW,
				[ CommitmentFilterType.OUTSTANDING ]: schemes.DEFAULT,
				[ CommitmentFilterType.OVERDUE ]: schemes.RED,
			};
		},
		filteredFilterCounts() {
			return this.filters.filter( filter => !this.omittedFilterTypes.includes( filter.type ) );
		},
	},
};
</script>

<style lang="scss" scoped>
.commitment-filters {
	list-style: none;
	margin: 0;
	padding: 0;
	width: 100%;
	display: flex;
	flex-direction: row;

	li {
		margin-right: 1rem;
	}
}
</style>
